module.exports = __webpack_public_path__ + "img/net_sales.a4af7e40.svg";